// Analyze Keyword > keyword suggestion > response keyword tabInfo
export const tabInfoDataFrame = [
  {
    index: 0,
    text: 'Apple Auto Fill',
    keywordDataList: null,
  },
  {
    index: 1,
    text: 'Google Play Suggestions',
    keywordDataList: null,
  },
  {
    index: 2,
    text: 'SearchAds Recommended Keywords',
    keywordDataList: null,
  },
  {
    index: 3,
    text: 'Similar Keywords',
    keywordDataList: null,
  },
  {
    index: 4,
    text: 'Related keywords',
    keywordDataList: null,
  },
  {
    index: 5,
    text: 'Trending Searches',
    keywordDataList: null,
  },
];
